import type { MedicationResource } from "../../types";
import auditData from "./us-resource-audit.json";

export type MedicationResourceAuditStatus =
  | "verified"
  | "missing"
  | "market-data-conflict"
  | "needs-clinical-review";

export type MedicationResourceAuditEntry = {
  medicationId: string;
  canonicalName: string;
  usBrands: string[];
  status: MedicationResourceAuditStatus;
  availabilityEvidence:
    | "availability"
    | "availability + brandsByCountry"
    | "legacy brandsByCountry only";
  sourcePolicy: string;
  verifiedOn: string;
  followUp?: string;
  resource?: MedicationResource;
};

/**
 * U.S. medication-resource audit reviewed on 2026-07-17.
 *
 * This is deliberately separate from the content blocks: the audit records
 * missing and conflicting market data as first-class outcomes instead of
 * making an unverified link look authoritative in the factsheet.
 */
export const US_MEDICATION_RESOURCE_AUDIT =
  auditData as MedicationResourceAuditEntry[];

export function getUsMedicationResource(medicationId: string) {
  return US_MEDICATION_RESOURCE_AUDIT.find(
    (entry) =>
      entry.medicationId === medicationId &&
      entry.status === "verified" &&
      entry.resource?.market === "US",
  )?.resource;
}
